import './Bulletins.scss';
import { useState } from 'react';
import { ErrorDisplayComponent, ErrorBoundary, PageTitle, Breadcrumbs } from '@gplibraries/react/components';
import BulletinsTable from '../../components/BulletinsTable/BulletinsTable.jsx';
import { useTokenProvider, useConfig, useLogger } from '@gplibraries/react/hooks';
import { useQuery } from '@tanstack/react-query';
import { fetchBulletins } from '../../api/bulletins.js';

export default function Bulletins() {

  const logger = useLogger();
  const { dealerAccessApiScope, dealerAccessApiHost } = useConfig();
  const [pageTitle, setPageTitle] = useState('Bulletins');
  const getToken = useTokenProvider({ scopes: [dealerAccessApiScope]});

  const { isLoading, error, data: bulletins } = useQuery({
    enabled: Boolean(getToken),
    queryKey: ['bulletins'],
    queryFn: () => getToken()
      .then(token => fetchBulletins(dealerAccessApiHost, token.accessToken))
      .then(res => res.json())
  })

  // @todo: refactor this to use ContentTable component

  return (
    <>

      <Breadcrumbs/>

      <PageTitle>{pageTitle}</PageTitle>

      <section className={'block shadow full'}>
        <ErrorBoundary
          fallback={<ErrorDisplayComponent message={'Bulletins could not be loaded.'}/>}
          logger={logger}
        >
          <BulletinsTable
            bulletins={bulletins}
            error={error}
            loading={isLoading}
            minWidth={'840px'}
            pageLimit={25}
            setPageTitle={setPageTitle}
          />
        </ErrorBoundary>

      </section>

    </>
  );
}